import { http } from './http';
import type { ExecuteRequest, ExecuteResponse } from '@/types/domain';

export const queryApi = {
  execute: (req: ExecuteRequest, signal?: AbortSignal) =>
    http.post<ExecuteResponse>('/query/execute', req, { signal }).then(r => r.data),

  explain: (req: ExecuteRequest, signal?: AbortSignal) =>
    http.post<{ plan: string }>('/query/explain', req, { signal }).then(r => r.data),
};
